import React from 'react'

interface PreloaderProps {
  preloaderClass?: string
}

export const Preloader: React.FC<PreloaderProps> = props => {
  let classes = 'unbridaled-preloader preloader'
  const { preloaderClass } = props
  if (preloaderClass !== undefined) {
    classes += ' ' + preloaderClass + ' unbridaled-' + preloaderClass
  }
  return (
    <div className={classes}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
      >
        <g transform="rotate(0 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-1.328502415458937s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(30 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-1.2077294685990336s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(60 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-1.0869565217391304s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(90 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.9661835748792269s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(120 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.8454106280193235s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(150 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.7246376811594202s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(180 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.6038647342995168s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(210 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.48309178743961345s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(240 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.3623188405797101s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(270 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.24154589371980673s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(300 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="-0.12077294685990336s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
        <g transform="rotate(330 50 50)">
          <rect x="47.5" y="21" rx="0.28" ry="0.28" width="5" height="14" fill="#5a5a5a">
            <animate
              attributeName="opacity"
              values="1;0"
              keyTimes="0;1"
              dur="1.4492753623188404s"
              begin="0s"
              repeatCount="indefinite"
            ></animate>
          </rect>
        </g>
      </svg>
    </div>
  )
}
